<div *ngIf="isLoading" class="progressBarContainer" [@fade]>
    <div class="progressBar">
    </div>
  </div>
